import { IObservable, Observable } from '@1js/oil-externals/rx';
import { LaunchAction } from '../../shared/services/url-launcher.service';
import { CommercialApps } from '../models/app.model';
import { SearchResultType } from '../search-instrumentation.service';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';
import { GoToProps } from './goto.search-suggestion-renderer';

export class GoToSearchSuggestionProvider extends BaseSuggestionProvider {
    public static commercialApps: CommercialApps;
    private static readonly MIN_NUM_OF_CHARS: number = 1;
    private static readonly MAXCOUNT: number = 3;

    public createStream(searchText: string): IObservable<any> {

        const renderedResults: Array<string> = [];
        const apps: Array<object> = [];

        if (searchText?.trim() !== '') {
            const result: Array<object> = [];
            let text: string = searchText.replace(/\s/g, '').toLowerCase();

            // if search text starts with 'ms' or 'microsoft', remove them to have a better match.
            if (text.startsWith('ms')) {
                text = text.split('ms')[1];
            } else if (text.startsWith('microsoft')) {
                text = text.split('microsoft')[1];
            }

            if (text.length >= GoToSearchSuggestionProvider.MIN_NUM_OF_CHARS) {
                GoToSearchSuggestionProvider.commercialApps.getCommercialAppList().forEach(app => {
                    const name: string = app['AppName'].replace(/\s/g, '').toLowerCase();
                    if ( text.indexOf(name) === 0 || name.indexOf(text) === 0) {
                        result.push(app);
                        if (result.length === GoToSearchSuggestionProvider.MAXCOUNT) {
                            return false;
                        }
                    }
                });
            }

            result.forEach(app => {
                apps.push({
                    appName: app['AppName'],
                    contentLauncherEnabled: GoToSearchSuggestionProvider.capabilitiesService.capabilities.contentLauncherEnabled,
                    id: decodeURI(app['Url']),
                    isPwa: GoToSearchSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                    isDarkMode: GoToSearchSuggestionProvider.isDarkMode,
                    title: app['Title'],
                    iconClass: app['IconUnicodeCodepointCssClass'],
                    url: app['Url'],
                    referral: app['Referral'],
                    searchInstrumentationService: GoToSearchSuggestionProvider.searchInstrumentationService,
                    urlLauncherService: GoToSearchSuggestionProvider.urlLauncherService
                });
                renderedResults.push(app['Title']);
            });
        }

        GoToSearchSuggestionProvider.searchInstrumentationService.setRenderedProviderResults(SearchResultType.GoTo, renderedResults);
        return Observable.fromArray(apps);
    }

    public addGoToResults(searchText: string,  results: Array<object>): void {
        this.createStream(searchText).subscribe((goTo: GoToProps) => {
            results.push({
                appName: goTo.appName,
                description: GoToSearchSuggestionProvider.searchConfigService.config.resources.SearchSuggestionGoToLabelInSerp,
                iconClass: goTo.iconClass + ' serp-app-icon',
                id: goTo.id,
                isDarkMode: goTo.isDarkMode,
                title: goTo.title,
                url: goTo.url,
                onClick: (_: React.MouseEvent | React.KeyboardEvent) => {
                    if (goTo.contentLauncherEnabled) {
                        import('@office-start/launcher-service').then(
                            launchSvc => {
                                launchSvc.launchUrl(goTo.url, { action: 'OpenAutosuggestGoTo' });
                            }
                        );
                    } else {
                        goTo.urlLauncherService.openUrl(goTo.url, LaunchAction.OpenAutosuggestGoTo);
                    }
                }
            });
        });
    }

    public getId(): string {
        return 'goTo';
    }
}
